import { useDispatch, useSelector } from "react-redux";
import { SearchIcon } from "../../../../Utils/SvgIcons";
import {
  initialFilterStateTestCreation,
  tableHeaderServiceCreation,
  tableHeaderTestCreation,
} from "./helper";
import { useEffect } from "react";
import {
  getFacilityCategoryNetworkAction,
  getPreparationForCheckupAction,
  getTestCreationAction,
} from "../../../../redux/actions/TestPackageCreationAction";
import { useState } from "react";
import { AddTestCreationPopup } from "./AddTestCreationPopup";
import Modal from "react-modal";
import {
  getHVChargesForAction,
  getPackageTagListForAction,
  getTestTypeAction,
} from "../../../../redux/actions/TestPackagesAction";
import { getTagListNetworkAction } from "../../../../redux/actions/TestPackageNetworkAction";
import { API_URL_WITHOUT_USER } from "../../../../Utils/API";
import { getNetworkMenuId, getToken } from "../../../../Utils/types";
import CustomPagination from "../../../../common/CustomPagination";
import { TableHeaderAdmin } from "../../HelloAdmin/helper";
import { AddServiceCreationPopup } from "./AddServiceCreationPopup";

const TestCreationPage = ({
  setIsRowData,
  isRowData,
  setIsRowDataTest,
  searchFilterTest,
  searchFilter,
  setSearchFilterTest,
}) => {
  const dispatch = useDispatch();
  const [isAddTestCreation, setIsAddTestCreation] = useState({
    isOpen: false,
    rowData: null,
  });
  const [isAddServiceCreation, setIsAddServiceCreation] = useState({
    isOpen: false,
    rowData: null,
  });

  const [multiSelect, setMultiSelect] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [isLoadingExcel, setIsLoadingExcel] = useState(false);
  const globalReducer = useSelector((state) => state?.globalReducer);
  const TestPackageCreationReducer = useSelector(
    (state) => state?.TestPackageCreationReducer
  );

  useEffect(() => {
    dispatch(getHVChargesForAction());
    dispatch(getTestTypeAction());
    dispatch(getTagListNetworkAction());
    dispatch(getPackageTagListForAction());
    dispatch(
      getPreparationForCheckupAction({
        preparationForCheckup: "",
      })
    );
  }, []);
  useEffect(() => {
    if (isRowData !== null) {
      setSearchFilterTest({
        ...searchFilterTest,
        diagnosticCategoryId: isRowData?.diagnosticCategoryId,
        type: isRowData?.type,
      });
      dispatch(
        getTestCreationAction({
          ...searchFilterTest,
          type: isRowData?.type,
          diagnosticCategoryId: isRowData?.diagnosticCategoryId,
        })
      );
    }
  }, [isRowData]);

  const changeHandler = (name, value) => {
    setSearchFilterTest({ ...searchFilterTest, [name]: value });
  };

  const handleSearch = () => {
    setSearchFilterTest({ ...searchFilterTest, page: 1 });
    dispatch(getTestCreationAction({ ...searchFilterTest, page: 1 }));
  };

  const handleClearFilter = () => {
    setSearchFilterTest({
      ...initialFilterStateTestCreation,
      diagnosticCategoryId: isRowData?.diagnosticCategoryId,
    });
    dispatch(
      getTestCreationAction({
        ...initialFilterStateTestCreation,
        diagnosticCategoryId: isRowData?.diagnosticCategoryId,
      })
    );
    setMultiSelect([]);
    setSelectAll(false);
  };

  const downloadFile = () => {
    setIsLoadingExcel(true);
    const url = `${API_URL_WITHOUT_USER}/Test/ExportToExcelTestDetailsNetwork`;
    const data = {
      ...searchFilterTest,
      testIds: selectAll ? "" : multiSelect?.toString(),
      page: undefined,
      rows: undefined,
      type: isRowData?.type === "Services" ? "Service" : "Diagnostic",
    };
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: getToken(),
        MenuId: getNetworkMenuId()?.menuId,
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.blob())
      .then((blob) => {
        const filename = "testcreation.xlsx";
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setIsLoadingExcel(false);
      })
      .catch((error) => {
        console.error("Failed to fetch the file");
        setIsLoadingExcel(false);
      });
  };

  const SortHandler = (sortColumnName, sortDirection) => {
    setSearchFilterTest({
      ...searchFilterTest,
      page: 1,
      SortColumn: sortColumnName,
      sortDirection: sortDirection,
    });
    dispatch(
      getTestCreationAction({
        ...searchFilterTest,
        page: 1,
        SortColumn: sortColumnName,
        sortDirection: sortDirection,
      })
    );
  };

  const testIds = TestPackageCreationReducer?.getTestCreation?.map((ele) => {
    return ele?.testId;
  });

  return (
    <div className="right-section" style={{ padding: "20px" }}>
      <div className="card staff-details-section">
        <div className="card-body">
          <div
            className="back-buttondiv"
            onClick={() => {
              setIsRowData(null);
              setSearchFilterTest({
                ...searchFilterTest,
                testName: "",
                page: 1,
              });
            }}
          >
            <i className="fa-solid fa-circle-arrow-left"></i>
            <h6 style={{ cursor: "pointer" }}>Back</h6>
          </div>
          <h4
            className="font-bold text-highlight"
            style={{ letterSpacing: "1px" }}
          >
            {isRowData?.type === "Services"
              ? "Service Creation"
              : "Test Creation"}
            ({isRowData?.diagnosticCategory})
          </h4>
          <div className="row-filter">
            {isRowData?.type === "Services" ? (
              <>
                <input
                  type="text"
                  placeholder="SKU Name"
                  className="white-form-select"
                  value={searchFilterTest?.testName}
                  onChange={(e) => changeHandler("testName", e.target.value)}
                  onKeyPress={(event) => {
                    if (event.key === "Enter") {
                      handleSearch(event);
                    }
                  }}
                />
              </>
            ) : (
              <>
                <input
                  type="text"
                  placeholder="Test Name"
                  className="white-form-select"
                  value={searchFilterTest?.testName}
                  onChange={(e) => changeHandler("testName", e.target.value)}
                  onKeyPress={(event) => {
                    if (event.key === "Enter") {
                      handleSearch(event);
                    }
                  }}
                />
              </>
            )}

            <select
              className="white-form-select"
              value={
                searchFilterTest?.BusinessType === null
                  ? ""
                  : searchFilterTest?.BusinessType
              }
              onChange={(e) => {
                changeHandler(
                  "BusinessType",
                  e.target.value === "" ? null : e.target.value
                );
              }}
            >
              <option value="">Select Business Type</option>
              <option value="IBU"> IBU </option>
              <option value="CBU"> CBU </option>
              <option value="Both"> Both </option>
            </select>
            {searchFilterTest?.BusinessType !== null && (
              <select
                className="white-form-select"
                value={
                  searchFilterTest?.isActive === null
                    ? ""
                    : searchFilterTest?.isActive
                }
                onChange={(e) => {
                  changeHandler(
                    "isActive",
                    e.target.value === "" ? null : e.target.value
                  );
                }}
              >
                <option value="">Select Status</option>
                <option value="Y"> Active </option>
                <option value="N"> Inactive </option>
              </select>
            )}
            <div className="search" type="button" onClick={handleSearch}>
              <a className="sidebar-links">
                <SearchIcon />
                <span className="sidebar-link-text">Search</span>
              </a>
            </div>
            <div className="search" type="button" onClick={handleClearFilter}>
              <a className="sidebar-links">
                <span className="sidebar-link-text">Clear All</span>
              </a>
            </div>
          </div>
          <div className="row-results">
            <div className="d-flex gap-10">
              <select
                className="row-selectdropdown"
                value={searchFilterTest?.rows}
                onChange={(e) => {
                  setSearchFilterTest({
                    ...searchFilterTest,
                    page: 1,
                    rows: e.target.value,
                  });
                  dispatch(
                    getTestCreationAction({
                      ...searchFilterTest,
                      rows: e.target.value,
                      page: 1,
                    })
                  );
                }}
              >
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
              </select>
              <p className="results">
                Total <span>{globalReducer?.getTotalCount}</span> results
              </p>
            </div>
            <div>
              {multiSelect?.length ? (
                <div className="select_all_div">
                  {!selectAll && (
                    <>
                      <p>{multiSelect?.length} tests are selected</p>
                      <span
                        className="select_all_primary_cases"
                        onClick={() => setSelectAll(true)}
                      >
                        Select all {globalReducer?.getTotalCount} tests
                      </span>
                    </>
                  )}
                  {selectAll && (
                    <p>{globalReducer?.getTotalCount} tests are selected</p>
                  )}
                </div>
              ) : null}
            </div>
            <div className="d-flex gap-10">
              {isRowData?.type === "Diagnostics category" &&
                getNetworkMenuId()?.canEdit && (
                  <button
                    className={`btn search__btn`}
                    type="button"
                    onClick={() =>
                      setIsAddTestCreation({ isOpen: true, rowData: null })
                    }
                  >
                    <i className="fa-solid fa-plus pt-1 c-white"></i>&nbsp;
                    Create Test
                  </button>
                )}
              {isRowData?.type === "Services" &&
                getNetworkMenuId()?.canEdit && (
                  <button
                    className={`btn search__btn`}
                    type="button"
                    onClick={() =>
                      setIsAddServiceCreation({ isOpen: true, rowData: null })
                    }
                  >
                    <i className="fa-solid fa-plus pt-1 c-white"></i>&nbsp;
                    Create SKU
                  </button>
                )}
              <button
                className={`btn ${
                  !isLoadingExcel ? "search__btn" : "disabled_btn"
                }`}
                type="button"
                onClick={() => !isLoadingExcel && downloadFile()}
                disabled={!multiSelect?.length}
              >
                <i className="fa-solid fa-arrow-down"></i>&nbsp;
                {isLoadingExcel ? "Exporting..." : "Export To Excel"}
              </button>
            </div>
          </div>
          <div className="table-responsive __custom__properties">
            <table className="table">
              <thead>
                <tr className="avanishtbl">
                  <th>
                    <input
                      type="checkbox"
                      onClick={(e) =>
                        e?.target?.checked
                          ? (setSelectAll(false),
                            setMultiSelect([
                              ...new Set(
                                [
                                  ...multiSelect,
                                  ...TestPackageCreationReducer?.getTestCreation?.map(
                                    (ele) => {
                                      return ele?.testId;
                                    }
                                  ),
                                ].map((item) => item)
                              ),
                            ]))
                          : (setSelectAll(false),
                            setMultiSelect(
                              multiSelect?.length === 10
                                ? []
                                : multiSelect?.filter(
                                    (item) => !testIds.includes(item)
                                  )
                            ))
                      }
                      checked={testIds?.every((r) => multiSelect?.includes(r))}
                      className="form-check-input"
                      readOnly
                    />
                  </th>
                  {isRowData?.type === "Diagnostics category" && (
                    <>
                      {tableHeaderTestCreation?.map((ele, index) => {
                        return (
                          <TableHeaderAdmin
                            key={index}
                            header={ele?.name}
                            searchFilter={searchFilterTest}
                            SortHandler={SortHandler}
                          />
                        );
                      })}
                    </>
                  )}
                  {isRowData?.type === "Services" && (
                    <>
                      {tableHeaderServiceCreation?.map((ele, index) => {
                        return (
                          <TableHeaderAdmin
                            key={index}
                            header={ele?.name}
                            searchFilter={searchFilterTest}
                            SortHandler={SortHandler}
                          />
                        );
                      })}
                    </>
                  )}
                  <th scope="col">Action</th>
                </tr>
              </thead>
              <tbody>
                {TestPackageCreationReducer?.getTestCreation?.map(
                  (ele, index) => {
                    return (
                      <tr key={index}>
                        <td className="pl-18">
                          <input
                            type="checkbox"
                            onClick={(e) =>
                              e?.target?.checked
                                ? (setSelectAll(false),
                                  setMultiSelect([...multiSelect, ele?.testId]))
                                : (setSelectAll(false),
                                  setMultiSelect(
                                    multiSelect.filter(
                                      (value) => value !== ele?.testId
                                    )
                                  ))
                            }
                            checked={multiSelect?.some(
                              (element) => element === ele?.testId
                            )}
                            className="form-check-input"
                            readOnly
                          />
                        </td>
                        <td
                          className={`${
                            ele?.isActiveForProduct === "Y" ||
                            ele?.isActiveForPPHC === "Y"
                              ? `tbl-textgreen ${ele?.isProfile && "underline"}`
                              : `tbl-textred ${ele?.isProfile && "underline"}`
                          }`}
                          onClick={() => {
                            ele?.isProfile && setIsRowDataTest(ele);
                          }}
                        >
                          {ele?.testName}
                        </td>
                        <td>{ele?.facilityType}</td>
                        <td>{ele?.isProfile ? "Yes" : "No"}</td>
                        <td>{ele?.agreedRate}</td>
                        <td>{ele?.fasting}</td>
                        <td>{ele?.hvChargesFor}</td>
                        <td>{ele?.isActiveForPPHC === "Y" ? "Yes" : "No"}</td>
                        <td>
                          {ele?.isActiveForProduct === "Y" ? "Yes" : "No"}
                        </td>
                        <td
                          className="tbl-actionimg"
                          style={{
                            cursor: !getNetworkMenuId()?.canEdit
                              ? "default"
                              : "pointer",
                          }}
                          onClick={async () => {
                            if (getNetworkMenuId()?.canEdit) {
                              if (isRowData?.type === "Diagnostics category") {
                                await dispatch(
                                  getFacilityCategoryNetworkAction(
                                    ele?.facilityType
                                  )
                                );
                                await setIsAddTestCreation({
                                  isOpen: true,
                                  rowData: ele,
                                });
                              } else if (isRowData?.type === "Services") {
                                setIsAddServiceCreation({
                                  isOpen: true,
                                  rowData: ele,
                                });
                              }
                            }
                          }}
                        >
                          <img
                            src=".././images/edit-icon.png"
                            alt="exportsquare"
                          />
                        </td>
                      </tr>
                    );
                  }
                )}
              </tbody>
            </table>
          </div>
          <div className="pagination-row">
            {globalReducer?.getTotalCount !== 0 && (
              <CustomPagination
                totalCount={globalReducer?.getTotalCount}
                perPageData={searchFilterTest?.rows}
                searchFilter={searchFilterTest}
                setSearchFilter={setSearchFilterTest}
                apiCall={getTestCreationAction}
              />
            )}
          </div>
          <Modal
            isOpen={isAddTestCreation?.isOpen}
            className="modal-add-user-popup modal-role-user-popup"
            overlayClassName="overlay-history-popup network-z-index"
            ariaHideApp={false}
          >
            <AddTestCreationPopup
              isAddTestCreation={isAddTestCreation}
              setIsAddTestCreation={setIsAddTestCreation}
              searchFilterTest={searchFilterTest}
              isRowData={isRowData}
              setSearchFilterTest={setSearchFilterTest}
            />
          </Modal>
          <Modal
            isOpen={isAddServiceCreation?.isOpen}
            className="modal-add-user-popup modal-role-user-popup"
            overlayClassName="overlay-history-popup network-z-index"
            ariaHideApp={false}
          >
            <AddServiceCreationPopup
              isAddServiceCreation={isAddServiceCreation}
              setIsAddServiceCreation={setIsAddServiceCreation}
              searchFilterTest={searchFilterTest}
              isRowData={isRowData}
              setSearchFilterTest={setSearchFilterTest}
            />
          </Modal>
        </div>
      </div>
    </div>
  );
};

export default TestCreationPage;
